import { useMemo } from "react";
import { useAuth } from "react-oidc-context";
import { LdapGroup } from "tng-address-collection-shared/types/primitives.ts";

const additionallySuggestedGroups = ["tng-communications-all"];

export const useUserLdapGroups = (): Array<string> => {
  const auth = useAuth();

  return useMemo(() => {
    const getGroupsArrayFromCognito = (): unknown => {
      const value = auth.user?.profile["custom:ldap_groups"];
      return typeof value === "string" ? JSON.parse(value) : undefined;
    };
    const getGroupsArrayFromKeycloak = (): unknown[] | undefined => {
      const value = auth.user?.profile["groups"];
      return Array.isArray(value) ? value : undefined;
    };

    const parseGroups = (maybeGroupsArray: unknown) => {
      const parsedValue = LdapGroup.array().safeParse(maybeGroupsArray);
      return parsedValue.success ? parsedValue.data : null;
    };

    const userGroups =
      parseGroups(getGroupsArrayFromCognito()) ??
      parseGroups(getGroupsArrayFromKeycloak()) ??
      [];

    return [...new Set([...additionallySuggestedGroups, ...userGroups])].sort(
      (a, b) => a.localeCompare(b),
    );
  }, [auth]);
};
